import type { SpanT } from '../types';

/**
 * Removes frameIndex from the span array.
 * Returns the same reference if frameIndex is not covered by any span.
 * A single-frame span is removed entirely. A boundary frame shrinks the span.
 * A middle frame splits the span into two.
 */
export function removeFrameIndexFromSpan(spans: SpanT[], frameIndex: number): SpanT[] {
  let changed = false;
  const result: SpanT[] = [];
  for (const span of spans) {
    if (frameIndex < span.start || frameIndex > span.end) {
      result.push(span);
      continue;
    }
    changed = true;
    if (span.start === span.end) {
      // Single-frame span: remove entirely
      continue;
    }
    if (frameIndex === span.start) {
      result.push({
        start: span.start + 1,
        end: span.end
      });
    } else if (frameIndex === span.end) {
      result.push({
        start: span.start,
        end: span.end - 1
      });
    } else {
      // Middle of span: split into two
      result.push({
        start: span.start,
        end: frameIndex - 1
      });
      result.push({
        start: frameIndex + 1,
        end: span.end
      });
    }
  }
  return changed ? result : spans;
}